/* eslint-disable @typescript-eslint/no-explicit-any */
type propType = {
  formik: any;
  formType: 'candidate' | 'guarantor';
  apiError?: boolean;
};

const checkAccordionErrors = (props: propType): boolean => {
  const { formik, formType, apiError } = props;

  if (formType === 'candidate') {
    return (
      (formik.touched.name && formik.errors.name) ||
      (formik.touched.marital_status && formik.errors.marital_status) ||
      (formik.touched.day && formik.errors.day) ||
      (formik.touched.month && formik.errors.month) ||
      (formik.touched.year && formik.errors.year) ||
      (formik.touched.nationality && formik.errors.nationality) ||
      (formik.values.nationality === 'outra' &&
        formik.touched.nationalityOther &&
        formik.errors.nationalityOther) ||
      (formik.touched.birthplace && formik.errors.birthplace)
    );
  }

  if (formType === 'guarantor') {
    return (
      (formik.touched.name && formik.errors.name) ||
      (formik.touched.marital_status && formik.errors.marital_status) ||
      (formik.touched.day && formik.errors.day) ||
      (formik.touched.month && formik.errors.month) ||
      (formik.touched.year && formik.errors.year) ||
      (formik.touched.nationality && formik.errors.nationality) ||
      (formik.values.nationality === 'outra' &&
        formik.touched.nationalityOther &&
        formik.errors.nationalityOther) ||
      (formik.touched.birthplace && formik.errors.birthplace) ||
      (formik.touched.degree_of_relatedness &&
        formik.errors.degree_of_relatedness) ||
      (formik.touched.email && formik.errors.email) ||
      (formik.touched.phone_number && formik.errors.phone_number) ||
      (formik.touched.marital_regime && formik.errors.marital_regime) ||
      apiError
    );
  }

  return false;
};

const checkAccordionChecked = (props: propType): boolean => {
  const { formik, formType } = props;
  const accordionError = checkAccordionErrors(props);

  if (formType === 'candidate') {
    return (
      !accordionError &&
      formik.touched.name &&
      formik.values.marital_status &&
      formik.values.day &&
      formik.values.month &&
      formik.values.year &&
      (formik.values.nationality || formik.values.nationalityOthe) &&
      formik.touched.birthplace
    );
  }

  if (formType === 'guarantor') {
    return (
      !accordionError &&
      formik.values.name &&
      formik.values.marital_status &&
      formik.values.day &&
      formik.values.month &&
      formik.values.year &&
      (formik.values.nationality || formik.values.nationalityOthe) &&
      formik.values.birthplace &&
      formik.values.degree_of_relatedness &&
      formik.values.email &&
      formik.values.phone_number &&
      (formik.values.marital_status !== 'married' ||
        (formik.values.marital_status === 'married' &&
          formik.values.marital_regime))
    );
  }

  return false;
};

export { checkAccordionChecked, checkAccordionErrors };
